import React from 'react'
import ReactDOM from 'react-dom'
import { StateProvider } from './store'
import { App } from './App'
import './index.module.css'

ReactDOM.render(
  <React.StrictMode>
    <StateProvider>
      <App basename="/help-centre" />
    </StateProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
